import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import _pick from "lodash/pick";
import _size from "lodash/size";
import { AnyAction } from "redux";
import { CUSTOMER_TYPE, NUMBER_OF_BARRINGS_FOR_CHILDREN } from "../../../../../constants";
import { CustomerInfoState, LegalOwnerIndividual } from "../../../../../models/state";
import * as AUTH_AT from "../../../authentication/state/actionTypes";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const initialState = (): CustomerInfoState => ({
    isProductUserAgeOk: true,
    isCatalogListingOk: true,
    isCampaignAllowed: false,
    isEsimSelected: false,
    isBarringsUsed: false,
    isProductUserDifferentThanLegalOwner: false,
    isCampaignToggled: false,
    campaignIdsNotAllowed: [],
    hasValidSmartDiscount: false,
    maskedEmail: "",
    legalOwner: {},
    currentIsExistingMissingEmail: false,
    currentIsExistingPrepaidKBDSubscription: false,
    currentIsPrepaidAndContainsPostpaid: false,
    isSecretNumber: false,
    isOptingOutForTeliaXServices: false,
});

const handleLegalOwnerFromBankId = (
    state: Partial<LegalOwnerIndividual>,
    action: AnyAction,
): Partial<LegalOwnerIndividual> => {
    const { payload } = action;

    if (!_isEmpty(payload)) {
        return _pick(action.payload, ["birthDate", "firstName", "lastName", "postcode", "city", "street", "email"]);
    }

    return state;
};

const handleLegalOwnerConsentRequired = (
    state: Partial<LegalOwnerIndividual>,
    action: AnyAction,
): Partial<LegalOwnerIndividual> => {
    const { legalOwnerConsentRequired } = action.payload;

    // Create Legal Owner data
    if (legalOwnerConsentRequired) {
        const names = legalOwnerConsentRequired.name.split(" ").reverse();
        const legalOwner = {
            firstName: names.slice(1).reverse().join(" "),
            lastName: names[0],
            email: legalOwnerConsentRequired.email,
            phone: legalOwnerConsentRequired.phoneNumber,
        };
        return legalOwner;
    }

    return state;
};

const reducer = (state = initialState(), action: AnyAction): CustomerInfoState => {
    switch (action.type) {
        case AT.CHECKOUT_SET_VALUE:
            return {
                ...state,
                [action.field]: action.value,
            };
        case AT.CHECKOUT_SET_SELECTED_PHONE_NUMBER:
            return {
                ...state,
                currentType: action.customerType,
            };
        case fulfilled(AT.CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER):
            return {
                ...state,
                isBarringsUsed: _size(_get(action, "payload.barringsForBarn", [])) === NUMBER_OF_BARRINGS_FOR_CHILDREN,
                campaignIdsNotAllowed: _get(action, "payload.campaignIdsNotAllowed") || [],
            };
        case fulfilled(AT.CHECKOUT_CHECK_EXISTING_PHONE_NUMBER):
            return {
                ...state,
                currentType:
                    _get(action, "payload.isTeliaNumber") === true
                        ? CUSTOMER_TYPE.EXISTING
                        : _get(action, "payload.isB2BAllowedWithNewNumber")
                          ? CUSTOMER_TYPE.NEW
                          : CUSTOMER_TYPE.PORT_IN,
                currentIsPrepaidAndContainsPostpaid: _get(action, "payload.isPrepaidToPostpaid", false),
                currentIsExistingPrepaidKBDSubscription: _get(
                    action,
                    "payload.isExistingPrepaidKBDSubscription",
                    false,
                ),
                currentIsExistingMissingEmail: _get(action, "payload.isAccountMissingEmail", false),
                maskedEmail: _get(action, "payload.email"),
                legalOwner: handleLegalOwnerConsentRequired(state.legalOwner, action),
            };
        case fulfilled(AUTH_AT.AUTH_BANK_ID_GRANT):
            return {
                ...state,
                currentType: _get(action, "payload.accountType", null),
                legalOwner: handleLegalOwnerFromBankId(state.legalOwner, action),
            };
        case fulfilled(AT.CHECKOUT_REMOVE_SMART_DISCOUNT_FROM_HARDWARE_ITEM):
            return {
                ...state,
                hasValidSmartDiscount: false,
            };
        case fulfilled(AT.CHECKOUT_SET_MEMBER_DETAILS):
            return {
                ...state,
                isEmailTakenForTeliaSky: action.payload.isEmailTakenForTeliaSky,
                isEmailTakenForTeliaTrygg: action.payload.isEmailTakenForTeliaTrygg,
                shouldAddTeliaTrygg: action.payload.shouldAddTeliaTrygg,
                shouldAddTeliaSky: action.payload.shouldAddTeliaSky,
            };
        case fulfilled(AT.CHECKOUT_RESET_ORDER):
        case fulfilled(AT.CHECKOUT_SET_MAIN_SUBSCRIPTION):
            return initialState();
        default:
            return state;
    }
};

export default reducer;
